function getDefaultMix(dataset) {
    const unitMix = [];
    const groups = dataset.apartments.categories;
    const ratio = 1 / Object.keys(groups).length;
    for (const key in groups) {
        const groupId = key;
        const apartmentNames = groups[key];
        unitMix.push({ label: groupId, apartmentNames, ratio });
    }
    return unitMix;
}

export { getDefaultMix };
//# sourceMappingURL=get-default-mix.js.map
